module.exports = __webpack_public_path__ + "static/img/5.ba05d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hlw/5.png
// module id = 4Gto
// module chunks = 1